import setGlobalState from '../../../redux/setGlobalState';

/**
 * Drop everything the chat holds about the event it was collecting, run before the wizard of
 * a newly created event opens.
 *
 * currentFormValues reaches the server as "already filled", and the agent is told to re-send
 * every value it already knows — so left behind it both stops the asks for fields the new
 * event never got and copies the previous event's date, venue and artists onto it.
 *
 * The wizard flags are per-event but live in ui.event, which changeEvent never clears — it
 * only resets the event slice — so without this the new wizard picks its steps by the
 * previous event (a scheduled event hides the date step, a duplicate adds its own).
 */
export function resetAgentEventState(): void {
    setGlobalState('aiAgent.currentFormValues', null);
    setGlobalState('aiAgent.createdDraftFields', null);
    setGlobalState('ui.event.isScheduled', false);
    setGlobalState('ui.event.isOpenLocaleStep', null);
    setGlobalState('ui.event.duplicateSourceEid', null);
}
